// Setted 0 for anti flickering effect also this value fires for not targeting pages.
export const DEFAULT_FEATURE_VALUE = 0;
// Feature value for Control variation of experiment
export const CONTROL_FEATURE_VALUE = 1;

export type ExperimentConfig = {
  targetPathname: string; // '/',
  featureId: string; // 'home-split',
  alternativeUrls: string[]; // ['/home.html'],
};